import React, { Fragment } from "react"
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../config/theme';
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import Banner from '../../components/users-sessions-new/Banner/Banner'
import Content from '../../components/users-sessions-new/Content/Content'
import AlertBar from '../../components/AlertBar'

const Page = styled.div`
  background-color: ${props => props.theme.colors.white};
`

class UsersSessionsNew extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      alertMessage: "",
    }
  }

  setAlertMessage = (message) => {
    this.setState({alertMessage: message})
  }

  render () {
    return (
      <Fragment>
        {this.state.alertMessage && <AlertBar message={this.state.alertMessage} />}
        <ThemeProvider theme={theme}>
          <Navbar theme="transparent"
            roleDashboardPath={this.props.roleDashboardPath}
            roleProfilePath={this.props.roleProfilePath}
            userSignedIn={this.props.userSignedIn}
            isInvestor={this.props.isInvestor}
            currentRole={this.props.isInvestor}
            name={this.props.name}
            csrfToken={this.props.csrfToken}
          />
          <Page>
            <Banner />
            <Content
              csrfToken={this.props.csrfToken}
              newUserPasswordPath={this.props.newUserPasswordPath}
              userSessionPath={this.props.userSessionPath}
              setAlertMessage={this.setAlertMessage}
            />
          </Page>
          <Footer />
        </ThemeProvider>
      </Fragment>
    );
  }
}

export default UsersSessionsNew;
